import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";

export default function PromptDialog({ open, onOpenChange, title, placeholder, confirmLabel = "Create", onConfirm, testId }) {
  const [value, setValue] = useState("");

  function confirm() {
    if (!value.trim()) return;
    onConfirm(value.trim());
    setValue("");
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setValue(""); onOpenChange(o); }}>
      <DialogContent data-testid={testId} aria-describedby={`${testId}-description`}>
        <DialogHeader>
          <DialogTitle className="font-serif text-ink">{title}</DialogTitle>
          <DialogDescription id={`${testId}-description`}>{placeholder}</DialogDescription>
        </DialogHeader>
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          autoFocus
          onKeyDown={(e) => e.key === "Enter" && confirm()}
          data-testid={`${testId}-input`}
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Cancel</Button>
          <Button disabled={!value.trim()} onClick={confirm} data-testid={`${testId}-confirm`}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
